import { SxProps, Theme } from '@mui/material';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },

  bookedNoteContainer: {
    padding: '10px',
    backgroundColor: 'eventChip.booked',
    mb: { xs: 0, md: '16px' },
    mt: { xs: 2, md: 0 },
    borderRadius: '8px',
    alignSelf: 'flex-start',
  },

  bookedNote: {
    color: 'common.counterRed',
    fontWeight: '500',
    fontSize: '12px',
  },

  subContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'secondary.main',
    padding: '12px',
    borderRadius: '9px',
    mb: '16px',
    mt: { xs: 2, md: 0 },
  },

  noteContainer: {
    marginRight: '10px',
  },

  subTitle: {
    fontSize: 14,
    color: 'grey.800',
    fontWeight: '400',
    marginBottom: '-7px',
    whiteSpace: 'nowrap',
  },

  note: {
    fontSize: 12,
    color: 'grey.800',
  },

  title: {
    fontWeight: '600',
    fontSize: 14,
    color: 'common.grey850',
  },

  dateBoxGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    columnGap: '10px',
  },

  timeContainer: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },

  dateBoxContainer: {
    padding: '12px',
    boxShadow: '0px 1.88px 22.58px 0px #00000014',
    mt: '12px',
    borderRadius: '9px',
    backgroundColor: 'secondary.main',
  },

  labelClass: { fontSize: 12, ml: '4px' },

  customCheckboxClass: { padding: 0, mt: '-4px' },

  requestCheckbox: { padding: 0, mr: '10px' },
  contractTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  contractTitle: {
    fontWeight: '700',
    fontSize: 12,
    textTransform: 'capitalize',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
